import { useState, useEffect, useMemo } from 'react';
import { fetchRoutes } from '../services/timetableAPI';
import { sortRoutesByNumber } from '../utils/timetable';

export default function useRoutes(searchTerm = '') {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        setLoading(true);
        const data = await fetchRoutes();
        if (!cancelled) {
          setRoutes(data);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Błąd pobierania listy linii:', err);
          setError('Nie udało się pobrać listy linii');
          setLoading(false);
        }
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  const filteredRoutes = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return sortRoutesByNumber(routes);
    const filtered = routes.filter(
      r => r.routeShortName.toLowerCase().includes(term)
        || (r.routeLongName && r.routeLongName.toLowerCase().includes(term))
    );
    return sortRoutesByNumber(filtered);
  }, [routes, searchTerm]);

  return { routes, filteredRoutes, loading, error };
}
